import React from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown, Tooltip } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { roleUseMutation } from "../hooks";
import RoleConst from "../role-const";
import { EntityRemoveButton, Localize } from "components/service";
import { localizeByKey, localizeByKeyStatic } from "components/service/localize";
import Icons from "components/icons";
import { usePermissionByObject } from "components/permissions";


interface IRoleActionFieldProps
{
    roleId: string;
    roleName: string;
}

const RoleActionField: React.FC<IRoleActionFieldProps> = ({ roleId, roleName }) =>
{
    const navigate = useNavigate();
    const { hasPermission: hasUpdatePermission } = usePermissionByObject(RoleConst.permissions.UPDATE);
    const { hasPermission: hasDeletePermission } = usePermissionByObject(RoleConst.permissions.DELETE);

    const { _setMutationRoleDelete, loadingMutationRoleDelete } =
        roleUseMutation.delete(roleId);

    const handleDelete = async (options: any) => {
        if (!hasDeletePermission) {
            return Promise.reject(new Error('Access denied'));
        }
        return _setMutationRoleDelete(options);
    };

    const items = [
        {
            label: (
                <Tooltip
                    title={!hasUpdatePermission ? `${localizeByKeyStatic('PERMISSION.Error_AccessDenied')}: ${localizeByKeyStatic(RoleConst.permissions.UPDATE.slug)}` : undefined}
                    placement="left"
                >
                    <span style={{
                        display: "flex",
                        alignItems: "center",
                        opacity: !hasUpdatePermission ? 0.5 : 1
                    }}>
                        <Icons.Edit />
                        <Localize>MENUS_DROP.Label_Edit</Localize>
                    </span>
                </Tooltip>
            ),
            key: "1",
            onClick: hasUpdatePermission ? () => navigate(`${RoleConst.basePath}/${roleId}`) : undefined,
            disabled: !hasUpdatePermission,
        },
        {
            key: "2",
            label: (
                <EntityRemoveButton
                    modalButton={
                        <Tooltip
                            title={!hasDeletePermission ? `${localizeByKeyStatic('PERMISSION.Error_AccessDenied')}: ${localizeByKeyStatic(RoleConst.permissions.DELETE.slug)}` : undefined}
                            placement="left"
                        >
                            <span style={{
                                display: "flex",
                                alignItems: "center",
                                opacity: !hasDeletePermission ? 0.5 : 1
                            }}>
                                <Icons.Delete />
                                <Localize>MENUS_DROP.Label_Delete</Localize>
                            </span>
                        </Tooltip>
                    }
                    nameEntity={localizeByKey("ENTITY.Modal_Title_Role")}
                    dataNameEntity={roleName}
                    loading={loadingMutationRoleDelete}
                    deleteMutation={handleDelete}
                    variables={{
                        id: roleId,
                    }}
                />
            ),
            disabled: !hasDeletePermission,
        },
    ];

    return (
        <Dropdown
            placement="bottomRight"
            menu={{ items }}
            overlayClassName="drop-more-menu"
            arrow
        >
            <EllipsisOutlined className="btn-more" />
        </Dropdown>
    );
};

export default RoleActionField;